<template>

    <button class="menu-item" :class="{ active: active }">
        <div class="label">
            <span class="title">{{ title }}</span>
            <span v-if="subtitle" class="subtitle">{{ subtitle }}</span>
        </div>
        <div v-if="active" class="accessory">
            <i class="fas fa-check"></i>
        </div>
    </button>

</template>

<style scoped lang="scss">

    .menu-item {

        align-items: center;
        appearance: none;
        background: #fff;
        border: 1px solid $color-rule;
        border-radius: 3px;
        display: flex;
        justify-content: space-between;
        min-height: 40px;
        overflow: hidden;
        text-align: left;
        text-decoration: none;
        transition: background-color .3s;
        user-select: none;

        &:hover, &.active {
            background-color: $color-bg;
        }

        .label {
            overflow: hidden;
            padding: 9px 12px;
            span {
                display: block;
                line-height: 1.6em;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
            .title {
                @include font-medium(13px);
                color: $color-text;
            }
            .subtitle {
                @include font-medium(11px);
                color: $color-muted;
                margin-bottom: 2px;
           }
        }

        .accessory {
            color: $color-primary;
            font-size: 12px;
            padding: 0 12px;
        }

    }

</style>

<script>

export default {

    props: {
        title: {
            type: String,
            required: true,
        },
        subtitle: {
            type: String,
        },
        icon: {
            type: String,
        },
        active: {
            type: Boolean,
            default: false,
        },
    },

}

</script>
